import dayjs from "dayjs";

export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear().toString();

    return `${day}-${month}-${year}`;
}

export function formatDateInYYMMDD(dateStr: string) {
    // Parse the date using dayjs
    const date = dayjs(dateStr, 'M/D/YYYY');

    // Format the date as "DD-MM-YYYY"
    return date.format('YYYY-MM-DD');
}
export function formatDateString(dateStr: string) {
    const someDay = new Date (dateStr);
    const convertDay = someDay.toLocaleDateString();
    return convertDay;
}

export function formatDateInDDMMYY(dateStr: string) {
    // Parse the date using dayjs
    const date = dayjs(dateStr, 'M/D/YYYY');

    // Format the date as "DD-MM-YYYY"
    return date.format('DD-MM-YYYY');
}

export const getMaxRecurDays = (startDate: string, endDate: string) => {
    const d1 = dayjs(startDate, 'M/D/YYYY');
    const d2 = dayjs(endDate, 'M/D/YYYY');
    const differenceInDays = d2.diff(d1, 'day');
    return Math.abs(differenceInDays); 
  }

export const isNullOrEmptyObject = (obj: Record<string, any>) => {
    return (Boolean(obj) && Object.keys(obj).length > 0) ? false : true;
}
